import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { Table } from '../../domain/models/table';
import { TableService } from '../../domain/services/table.service';

@Component({
    selector: 'app-header',
    imports: [
        CommonModule,
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
  tableSubscription: Subscription;
  backgroundImage?: string;

  constructor(
    private tableService: TableService,
  ) {
    if(!this.tableSubscription) {
      this.tableSubscription = this.tableService.$openedTable.subscribe((table: Table | null) => {
        if(table) {
          this.backgroundImage = table.installation.bannerImage;
        }
      })
    }
  }
}
